module.exports = __webpack_public_path__ + "img/Janatavani.967bd190.jpg";